import React, { useState } from "react";
import Billing from "./billing";
import AttendReport from "./attend";
import AttemptReport from "./attempt";
import PaymentReport from "./payment";
import DoctorReports from "./doctors";
import { Tooltip } from "@material-ui/core";
import CostomDateFilter from "./customDateFilter";

const ClinicReports = () => {
    const [open, setOpen] = useState(false);
    const [dates, setDates] = useState({
        from: new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0),
        to: new Date(new Date().getFullYear() + 1, 0).setHours(23, 59, 59, 999),
        dateType: "year"
    })


    const handleOpen = () => {
        setDates({...dates, to:new Date().setHours(23, 59, 59, 999).valueOf()});
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <div className="baseContainer">
            <div className="flexCol respdngHSM">
                <div className="flexRow respdngVHMD alignCntr">
                    <div className="flexMinWidthRow">
                        <h2 className="topHdngTxt">Reports</h2>
                    </div>
                    <div className="flexAutoRow">
                        <div className="flexRow filterBtn">
                            <Tooltip title="Day" onClick={
                                () => setDates({
                                    from: new Date(new Date().setHours(0, 0, 0, 0)).valueOf(),
                                    to: new Date(new Date().setHours(23, 59, 59, 999)).valueOf(),
                                    dateType:"day"
                                })
                            }>
                                <span className="brdrRSM pdngXS pointer filterText">Day</span>
                            </Tooltip>
                            <Tooltip title="Week">
                                <span className="brdrRSM pdngXS pointer filterText" onClick={
                                    () => setDates({
                                        from: new Date(new Date().setDate(new Date().getDate() - new Date().getDay())).setHours(0, 0, 0, 0),
                                        to: new Date(new Date().setDate(new Date().getDate() - new Date().getDay() + 6)).setHours(23, 59, 59, 999),
                                        dateType: "week"
                                    })
                                }>Week</span>
                            </Tooltip>
                            <Tooltip title="Month" onClick={
                                () => setDates({
                                    from: new Date(new Date(new Date().getFullYear(), new Date().getMonth(), 1)).setHours(0, 0, 0, 0),
                                    to: new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0).setHours(23, 59, 59, 999),
                                    dateType: "month"
                                })
                            }>
                                <span className="brdrRSM pdngXS pointer filterText">Month</span>
                            </Tooltip>
                            <Tooltip title="Year">
                                <span className="brdrRSM pdngXS pointer filterText" onClick={
                                    () => setDates({
                                        from: new Date(new Date().getFullYear(), 0, 1).setHours(0, 0, 0, 0),
                                        to: new Date(new Date().getFullYear() + 1, 0).setHours(23, 59, 59, 999),
                                        dateType: "year"
                                    })
                                }>Year</span>
                            </Tooltip>
                            <Tooltip title="Custom" onClick={handleOpen}>
                                <span className=" pdngXS pointer filterText">Custom</span>
                            </Tooltip>
                        </div>
                    </div>
                </div>
                <div className="flexMinWidthRow">
                    <div className="flexWrap">
                        <Billing dates={dates} />
                        <AttendReport dates={dates} />
                        <AttemptReport dates={dates} />
                        <PaymentReport dates={dates} />
                        <DoctorReports dates={dates} />
                    </div>
                </div>
            </div>
            {open && <CostomDateFilter open={open} handleClose={handleClose} setDates={setDates} dates={dates} />}
        </div>
    );
};
export default ClinicReports;
